import { logger } from '@/util/logger';

const {$} = window;
window.multiselects = {};

export default function MultiSelect(id, settings) {
    window.multiselects[id] = this;
    this.id = id;

    /* 
        Settings
        ==================
        emptyText: String 
        noOptionsText: String
        postParamName: String (name of the API method to be used for dynamic async calls)
        sortLabel: Boolean (determines whether to sort field label alphabetically or not)
        convert: Boolean (create the multiselect from a dropdown control)
    */
    this.s = settings || {};
    this.emptyText = this.s.emptyText || 'Filter Selection';
    this.noOptionsText = this.s.noOptionsText || 'No Options Available';
    this.postParamName = this.s.postParamName || '';
    this.booSortLabel = typeof this.s.sortLabel !== 'undefined' ? this.s.sortLabel : true;

    this.$select;
    this.$outer;
    this.$field;
    this.$optionList;
    this.$options;
    this.$checkboxes;
    this.$selectAll;
    this.$internalValue;

    this.selectAllEnabled = false;
    this.allSelected = false;
    this.SELECTALL_ENABLED_AMOUNT = 10;

    this.deactivateTimer;
    this.isActive = false;

    const _labelMap = {};

    this.onValueChanged = this.s.onValueChanged || '';

    this.createMultiSelectOption = function(ddOption, fieldName) {
        const option = document.createElement('div');
        const checkbox = document.createElement('input');
        const label = document.createElement('label');
                
        option.className = 'multi-select_option js-multiselect-option ';
        option.tabIndex = -1;
    
        checkbox.type = 'checkbox';
        checkbox.tabIndex = '-1';
        checkbox.name = fieldName;

        if (ddOption) {
            checkbox.value = ddOption.value;
            checkbox.className = 'multi-select_checkbox js-multiselect-checkbox';
        } else {
            checkbox.className = 'multi-select_checkbox js-multiselect-checkbox js-select-all';
        }

        label.className = 'multi-select_label';
        label.htmlFor = fieldName;
        
        if (ddOption) {
            label.textContent = ddOption.textContent;
            label.value = ddOption.textContent;
            if (ddOption.getAttribute('data-selected')) {
                checkbox.checked = true;
            }
        } else {
            label.textContent = 'Select All';
        }

        if (ddOption) {
            option.title = ddOption.textContent;
        }
        option.appendChild(checkbox);
        option.appendChild(label);

        return option;
    };


    const _updateInternalValue = () => {
        if (!this.$internalValue.length) {
            return;
        }

        // update JSON value for use in code behind
        this.$internalValue[0].value = JSON.stringify(this.getValue());
    };

    this.updateSelectionLabel = function() {
        if (this.getValue().length) {
            this.$field.removeClass('is-empty');
            this.$value.text(this.getLabel());
        } else {
            this.$field.addClass('is-empty');
            this.$value.text(this.emptyText);
        }
    };

    // get the value of all checked boxes as an array
    this.getValue = function() {
        // When enabled, "select all" is the first checkbox in the list. Ignore that checkbox when getting the value.
        const $checkboxes = this.selectAllEnabled ? this.$checkboxes.slice(1) : this.$checkboxes;
        return $.map($checkboxes.filter(':checked'), (elem) => elem.value);
    };

    // get a comma separated string of labels for each selected value
    this.getLabel = function(){
        return this.getValue().map((val) => _labelMap[val])
            .join(', ');
    };

    this.activate = function() {
        const that = this;

        this.$outer.addClass('is-active');
        this.$optionList.addClass('is-open');

        this.setOptionListPosition();

        $(window).on(`resize.${this.id}`, function() {
            that.setOptionListPosition();
        });

        this.isActive = true;
    };

    this.setOptionListPosition = function() {
        const $offsetParent = this.$optionList.offsetParent();
        let topPos = this.$outer.offset().top + this.$outer.height();
        let leftPos = this.$outer.offset().left - (this.$optionList.width() - this.$outer.width());

        if ($offsetParent.length) {
            topPos -= $offsetParent.offset().top;
            leftPos -= $offsetParent.offset().left;
        }

        this.$optionList.css({
            top:topPos,
            left:leftPos
        });
    };

    this.deactivate = function() {
        // reset scroll position to top when opened again
        this.$optionList.scrollTop(0);

        this.$outer.removeClass('is-active');
        this.$optionList.removeClass('is-open');
        this.isActive = false;

        $(window).off(`resize.${  this.id}`);
    };

    this.scheduleDeactivate = function(t) {
        const that = this;
        this.deactivateTimer = setTimeout(function() {
            that.deactivate();
        }, t);

    };

    this.cancelDeactivate = function() {
        const that = this;
        clearTimeout(that.deactivateTimer);
    };

    this.toggleSelected = function(checkbox, e) {
        if (e.type === 'toggle') checkbox.checked = !checkbox.checked;

        if ($(checkbox).hasClass('js-select-all')) {
            this.toggleAll(checkbox.checked, this);

            return;
        }

        if (this.allSelected && !checkbox.checked) {
            this.$selectAll.prop('checked', false);
            this.allSelected = false;
        }

        this.updateSelectionLabel();
        _updateInternalValue();

        if (typeof this.onValueChanged === 'function') {
            this.onValueChanged();
        }
    };

    this.toggleAll = function(checkAll) {
        const that = this;
        if (checkAll) {
            // check all options
            this.$checkboxes.each(function() {
                this.checked = true;
            });

            that.allSelected = true;
        } else {
            // uncheck all options
            this.$checkboxes.each(function() {
                this.checked = false;
            });

            that.allSelected = false;
        }

        _updateInternalValue();
        this.updateSelectionLabel();
    };

    const _createLabelMap = () => {
        const that = this;

        this.$options.each(function() {
            const cb = this.querySelector('.js-multiselect-checkbox');
            const label = this.querySelector('.multi-select_label');

            _labelMap[cb.value] = label.textContent;
        });
    };

    this.attachEvents = function() {
        const that = this;

        this.$checkboxes.on('change toggle',function(e){
            that.toggleSelected(this, e);
        });

        // ---------------
        // Click Events
        // ---------------
        this.$field.on('click', function() {
            // open options if not already open
            if (that.isActive) return;

            that.activate();

            $(this).focus();
        });

        this.$options.on('click', function(e) {
            if (e.target.nodeName === 'INPUT') {
                return;
            }
            $(this).find('.js-multiselect-checkbox').trigger('toggle');
        });

        // ---------------
        // Focus Events
        // ---------------
        this.$field.add(this.$options)
            .on('blur', function() {
                that.scheduleDeactivate(50);
            })
            .on('focus', function() {
                that.cancelDeactivate();
            });

        this.$options.on('focus', function() {
            that.cancelDeactivate();
        });

        this.$checkboxes.on('focus', function() {
            $(this).parent().focus();
        });

        // IE focuses the scroll container when it is clicked, so return focus
        // to last focused element when options list is focused
        this.$optionList.on('focus', function() {
            that.$field.focus();
        });


        // ---------------
        // keyboard Events
        // ---------------
        this.$field.on('keydown', function(e) {
            // handle tab
            if (window.isTabKey(e)) {
                that.scheduleDeactivate(50);
                return;
            }

            // handle down arrow
            if (window.isDownArrowKey(e)) {
                that.activate();
                that.$options.first().focus();

                // don't scroll the options list, let the focus handle that.
                e.preventDefault();
                return;
            }
        });

        this.$options.on('keydown', function(e) {
            switch (e.keyCode) {
                case 9: // handle tab
                    that.scheduleDeactivate(50);
                    break;
                case 40: // handle down arrow
                    $(this).next().focus();

                    // don't scroll the options list, let the focus handle that.
                    e.preventDefault();
                    break;
                case 38: // handle up arrow
                    $(this).prev().focus();

                    // don't scroll the options list, let the focus handle that.
                    e.preventDefault();
                    break;
                case 13:
                case 32: // handle spacebar and enter keys ('treat as click')
                    $(this).find('.js-multiselect-checkbox').trigger('toggle');
                    $(this).focus();
                    // don't scroll the options list
                    e.preventDefault();
                    break;
                default:
                    // do nothing;
                    break;
            }
        });

        // Fix for IE causing selected node to lose focus and therefore close multiselect
        // options panel when the panel is scrolled by clicking the scroll bar.
        if (window.isIE) {
            this.$optionList.on('scroll', function() {
                that.cancelDeactivate(that);
            });
        }
    };

    this.cacheSelectors = function() {
        this.$outer = $(`#${  this.id}`);
        this.$field = this.$outer.find('.multi-select_field');
        this.$value = this.$outer.find('.multi-select_value');
        this.$selectAll = this.$outer.find('.js-select-all');
        this.$internalValue = this.$outer.find('.js-multiselect-internal-value');

        // do a global query for these, because they are not necessarily children of the multiselect
        this.$optionList = $(`#${  this.id  }_options-list`);

        // children of OptionsList
        this.$options = this.$optionList.find('.js-multiselect-option');
        this.$checkboxes = this.$optionList.find('.js-multiselect-checkbox');
    };

    this.init = function() {
        const that = this;
        // convert a dropdown from a multiselect.
        // this must be done before selectors are cached
        // so that all the multiselect elements are added to the DOM
        if (this.s.convert) {
            this.$select = $(`#${  this.id}`);

            if (this.$select[0].nodeName !== 'SELECT') {
                logger.warn(`Cannot convert node of type ${  this.$select[0].nodeName  }. Node must be of type ${  this.$select[0].nodeName}`);
                return;
            }

            const multiSelect = document.createElement('div');
            const field = document.createElement('div');
            const value = document.createElement('div');
            const optionList = document.createElement('div');
            optionList.id = `${this.id  }_options-list`;
            const hf = document.createElement('input');
            const $options = this.$select.find('option');
            const fieldName = this.$select.attr('name');

            multiSelect.className = 'multi-select multi-select--dropdown';

            field.className = 'multi-select_field is-empty';
            field.tabIndex = 0;
            value.textContent = this.emptyText;
            value.className = 'multi-select_value';
            optionList.className = 'multi-select_options';
            hf.id = this.id
            hf.type = 'hidden';

            // Create select all option as first option in optionList
            if ($options.length >= this.SELECTALL_ENABLED_AMOUNT) {
                optionList.appendChild(this.createMultiSelectOption(null, fieldName));
                this.selectAllEnabled = true;
            }

            $options.each(function() {
                // if option is empty don't include it in the multi-select list
                if (!this.textContent) return;

                const o = that.createMultiSelectOption(this, fieldName);
                optionList.appendChild(o);
            });

            field.appendChild(value);
            multiSelect.appendChild(field);
            multiSelect.appendChild(optionList);
            multiSelect.appendChild(hf);

            // replace regular dropdown w/ multi-select dropdown
            $(multiSelect).insertBefore(this.$select);
            this.$select.remove();
            this.$select = null;
            multiSelect.id = this.id;
        }

        this.cacheSelectors();


        // if (this.s.checkboxNameOverride) {
        //     // if not converted it came from WUC_MultiSelect, so normalize the
        //     // checkbox "name" property to the id of the multiselect
        //     this.$checkboxes.each(function(){
        //         this.name = that.s.checkboxNameOverride;
        //     });
        // }


        if (!this.$options.length) {
            this.$field
                .text(this.noOptionsText)
                .addClass('is-disabled')
                .removeAttr('tabIndex');
        } else {
            _createLabelMap();
            _updateInternalValue();
            this.updateSelectionLabel();
            this.attachEvents();
        }
    };
}

// selectToMultiSelect plugin definition
$.fn.selectToMultiSelect = function(settings = {}) {
    settings.convert = true;

    if ($(this).data().emptyText) {
        settings.emptyText = $(this).data().emptyText;
    }

    const ms = new MultiSelect($(this).attr('id'), settings);
    ms.init();
};